<template>
<div>
    <div id="parent">

    </div>
</div>
</template>
<script>

export default {
    components: {},
    data() {
        return {
            msg: ''
        }
    },
    mounted() {

    },
    methods(){}
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// Init.vue?102d94e1